module.exports = __webpack_public_path__ + "static/img/example-1.20d9e16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/example-1.png
// module id = 3TZe
// module chunks = 2